import Vue from 'vue'
import VueRouter from 'vue-router'
import { message } from 'ant-design-vue'
import store from '@/store'
import routes from './routes'
import NProgress from "nprogress"; // 加载进度条
Vue.use(VueRouter)
//解决访问统一路由控制台报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//不需要登录的列表  
const passUrls = ['/login']
//路由拦截器
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (!store.getters.isLogin) {
    //未登录状态
    if (passUrls.indexOf(to.path) === -1) {
        //url需要登录 跳转到登录页
        message.error("请先登录！")
        return next('/login')
    }
  }
  //标题
  document.title = to.meta.title || 'JIAOMA-MES'
  return next()
})
router.afterEach(() => {
  NProgress.done()
});
export default router
